// import React from "react";
// import { Container, Row, Col, Image } from "react-bootstrap";
// import Header from "../work/header";
// import Footer from "../work/footer";
// import img from "../../assets/portrait-young-handsome-man-jacket-holding-laptop_171337-19839.avif";

// function KapilBhalla() {
//   return (
//     <div>
//       <Header />
//       <div
//         className="office-m-t"
//         style={{ backgroundColor: "#f8f9fa", padding: "50px 0" }}
//       >
//         <Container>
//           <Row className="align-items-center ">
//             <Col md={6}>
//               <h1 className="fw-bold">Kapil Bhalla</h1>
//               <h4 className="text-muted">Founder and Principal Architect</h4>
//             </Col>
//             <Col md={6}>
//               <Image
//                 src={img}
//                 alt="Kapil Bhalla"
//                 className="img-fluid custom-img"
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//       <Container>
//         <Row className="mb-5 mt-5">
//           <Col md={6}>
//             <h5 className="office-font-1">
//               <strong>Executive Education</strong>
//             </h5>
//             <p className="office-font-3">
//               Graduate School of Design (2008)
//               <br />
//               <p className="office-font-2">
//                 Harvard University, Boston, Massachusetts, USA
//               </p>
//             </p>

//             <h5 className="office-font-1">
//               <strong>Bachelor Education</strong>
//             </h5>
//             <p className="office-font-3">
//               Bachelor of Architecture (1985)
//               <br />
//               <p className="office-font-2">
//                 Sir J.J College of Architecture, Mumbai
//               </p>
//             </p>
//           </Col>

//           <Col md={6}>
//             <h5 className="office-font-1">
//               <strong>Master Education</strong>
//             </h5>
//             <p className="office-font-3">
//               Master of Architecture (1987)
//               <br />
//               <p className="office-font-2">
//                 Sir J.J College of Architecture, Mumbai
//               </p>
//             </p>
//           </Col>
//         </Row>

//         <Row className="mb-5">
//           <Col md={6}>
//             <p className="office-font-2">
//               SE-ARCH is regulated with a team of energetic leaders from
//               well-established education backgrounds that showcase a multitude
//               of talent and genuine creativity. It is true professionalism that
//               drives them to maintain strict schedules, communicate and
//               coordinate all relevant information and maintain healthy
//               relationships with the Clients, Consultants and Contractors.
//             </p>
//             <p className="office-font-2">
//               Their sense of camaraderie and team leadership skills strengthens
//               bond within the Studio, which results in a positive work
//               environment and ensures a high quality of work output. Along with
//               precision, a great attention to detail and valuable market
//               knowledge make certain of a holistic outlook. It is this ability
//               to taken on and distribute responsibility that facilitates SE-ARCH
//               to perform as one single coherent unit. SE-ARCH is regulated with
//               a team of energetic leaders from well-established education
//               backgrounds that showcase a multitude of talent and genuine
//               creativity. It is true professionalism that drives them to
//               maintain strict schedules, communicate and coordinate all relevant
//               information and maintain healthy relationships with the Clients,
//               Consultants and Contractors.
//             </p>
//             <p className="office-font-2">
//               Their sense of camaraderie and team leadership skills strengthens
//               bond within the Studio, which results in a positive work
//               environment and ensures a high quality of work output. Along with
//               precision, a great attention to detail and valuable market
//               knowledge make certain of a holistic outlook. It is this ability
//               to taken on and distribute responsibility that facilitates SE-ARCH
//               to perform as one single coherent unit.
//             </p>
//           </Col>

//           <Col md={6}>
//             <p className="office-font-2">
//               SE-ARCH is regulated with a team of energetic leaders from
//               well-established education backgrounds that showcase a multitude
//               of talent and genuine creativity. It is true professionalism that
//               drives them to maintain strict schedules, communicate and
//               coordinate all relevant information and maintain healthy
//               relationships with the Clients, Consultants and Contractors.
//             </p>
//             <p className="office-font-2">
//               Their sense of camaraderie and team leadership skills strengthens
//               bond within the Studio, which results in a positive work
//               environment and ensures a high quality of work output. Along with
//               precision, a great attention to detail and valuable market
//               knowledge make certain of a holistic outlook. It is this ability
//               to taken on and distribute responsibility that facilitates SE-ARCH
//               to perform as one single coherent unit. SE-ARCH is regulated with
//               a team of energetic leaders from well-established education
//               backgrounds that showcase a multitude of talent and genuine
//               creativity. It is true professionalism that drives them to
//               maintain strict schedules, communicate and coordinate all relevant
//               information and maintain healthy relationships with the Clients,
//               Consultants and Contractors.
//             </p>
//             <p className="office-font-2">
//               Their sense of camaraderie and team leadership skills strengthens
//               bond within the Studio, which results in a positive work
//               environment and ensures a high quality of work output. Along with
//               precision, a great attention to detail and valuable market
//               knowledge make certain of a holistic outlook. It is this ability
//               to taken on and distribute responsibility that facilitates SE-ARCH
//               to perform as one single coherent unit.
//             </p>
//           </Col>
//         </Row>
//       </Container>
//       <Footer />
//     </div>
//   );
// }

// export default KapilBhalla;

// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.css";
// import "../../style/contactPage/contactpage.scss"; // Aap apna relevant SCSS file update kar sakte ho
// import { Container, Row, Col, Spinner, Image } from "react-bootstrap";
// import Header from "../work/header";
// import Footer from "../work/footer";

// const API_BASE_URL = "https://infoglans.com/search/wp-json/wp/v2";

// function KapilBhalla() {
//   // const [acfData, setAcfData] = useState(null);
//   // const [imageUrl, setImageUrl] = useState("");
//   // const [error, setError] = useState(null);
//   // const [isLoading, setIsLoading] = useState(false);

//   // useEffect(() => {
//   //   const fetchKapilBhallaData = async () => {
//   //     try {
//   //       setIsLoading(true);
//   //       const res = await fetch(`${API_BASE_URL}/pages/202`);
//   //       const pageData = await res.json();

//   //       setAcfData(pageData.acf);

//   //       // If image exists, fetch image URL
//   //       if (pageData?.acf?.office_img) {
//   //         const imgRes = await fetch(`${API_BASE_URL}/media/${pageData.acf.office_img}`);
//   //         const imgData = await imgRes.json();
//   //         setImageUrl(imgData.source_url);
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching Kapil Bhalla data:", err);
//   //       setError(err);
//   //     } finally {
//   //       setIsLoading(false);
//   //     }
//   //   };

//   //   fetchKapilBhallaData();
//   // }, []);
//   const [imageUrl, setImageUrl] = useState("");

// useEffect(() => {
//   const fetchKapilBhallaData = async () => {
//     try {
//       const res = await fetch(`${API_BASE_URL}/pages/202`);
//       const pageData = await res.json();
//       setAcfData(pageData.acf);

//       // 🔽 Check for media ID
//       const mediaId = pageData?.acf?.office_img;
//       if (mediaId) {
//         const imgRes = await fetch(`${API_BASE_URL}/media/${mediaId}`);
//         const imgData = await imgRes.json();
//         setImageUrl(imgData.source_url); // ✅ This is the image URL you need
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   fetchKapilBhallaData();
// }, []);

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import { Container, Row, Col, Spinner, Image } from "react-bootstrap";
import Header from "../work/header";
import Footer from "../work/footer";

const API_BASE_URL = "https://infoglans.com/search/wp-json/wp/v2";

function KapilBhalla() {
  const [acfData, setAcfData] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchKapilBhallaData = async () => {
      try {
        setIsLoading(true);
        const res = await fetch(`${API_BASE_URL}/pages/202`);
        const pageData = await res.json();
        setAcfData(pageData.acf);

        // console.log("abc", pageData);

        // ✅ Fetch image if media ID exists
        const mediaId = pageData?.acf?.portfolio_img;
        if (mediaId) {
          const imgRes = await fetch(`${API_BASE_URL}/media/${mediaId}`);
          const imgData = await imgRes.json();
          setImageUrl(imgData.source_url);
        }
      } catch (err) {
        console.error("Error fetching Kapil Bhalla data:", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchKapilBhallaData();
  }, []);

  console.log("acfdat", acfData);

  return (
    <div>
      <Header />
      <div className="py-5">
        <h2 className="mb-4 fw-bold text-center">Kapil Bhalla Profile</h2>

        {isLoading && <p className="text-center">Loading...</p>}
        {error && (
          <p className="text-danger text-center">
            Something went wrong. Please try again later.
          </p>
        )}

        {acfData && (
          <>
          <div style={{
                background: "linear-gradient(to bottom, #DADEE3, #F8F8F9)",
                padding: "0px 70px",
                width:"100%"
              }}>
            <Container>
            <Row
              className="align-items-center mb-5"
              
              
            >
              <Col md={6}>
                <h3 className="fw-bold">{acfData.portfolio_title}</h3>
                <h5 className="text-muted">{acfData.portfolio_desc}</h5>
                <p>{acfData.kapil_bhalla_desc}</p>
              </Col>
              <Col md={6}>
                <Image
                  src={imageUrl}
                  alt="Kapil Bhalla"
                  className="img-fluid custom-img"
                />
              </Col>
            </Row>
            </Container>
            </div>
            <Container>
            <Row className="mb-4">
              <Col md={6}>
                <h5 className="fw-semibold office-font-1">Executive Education</h5>
                <p className="mb-2 office-font-3">{acfData.executive_education_title}</p>
                <p className="office-font-2">{acfData.executive_education_desc}</p>

                <h5 className="fw-semibold mt-4 office-font-1">Bachelor Education</h5>
                <p className="mb-2 office-font-3">{acfData.bachelor_education_title}</p>
                <p className="office-font-2">{acfData.bachelor_education_desc}</p>
              </Col>

              <Col md={6}>
                <h5 className="fw-semibold office-font-1">Master Education</h5>
                <p className="mb-2 office-font-3">{acfData.master_education_title}</p>
                <p className="office-font-2">{acfData.master_education_desc}</p>
              </Col>
            </Row>
            </Container>
            <Container>

            <Row>
              <Col md={6} className="office-font-2">
                <div dangerouslySetInnerHTML={{ __html: acfData.left_text }} />
              </Col>
              <Col md={6} className="office-font-2">
                <div dangerouslySetInnerHTML={{ __html: acfData.right_text }} />
              </Col>
            </Row>
            </Container>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default KapilBhalla;
